<template>
  <v-row dense>
    <v-col cols="12">
      <v-card class="card-border">
        <v-card-text>
          <v-row dense>
            <v-col cols="12" sm="12" md="3">
              <SelectEmpresa @onChanged="empresas = $event" :multiple="true" />
            </v-col>

            <v-col cols="12" sm="12" md="3">
              <SelectColaborador
                v-show="!todosColaboradores"
                :multiple="true"
                :empresas="empresas"
                @onChanged="colaboradores = $event"
              />
            </v-col>

            <v-col cols="12">
              <v-checkbox
                v-model="todosColaboradores"
                label="Para todos vendedores"
                color="blue darken-2"
              />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>

    <v-col cols="12">
      <v-card class="card-border">
        <v-card-text>
          <v-row dense>
            <v-col cols="12" sm="12" md="6">
              <SelectCampanha :empresas="empresas" @onChanged="campanha = $event" />
            </v-col>

            <v-col cols="12">
              <v-divider></v-divider>
            </v-col>

            <template v-if="!todosColaboradores">
              <v-col cols="12" v-for="(colaborador, i) in colaboradores" :key="i">
                <v-card>
                  <v-card-text>
                    <v-row dense>
                      <v-col cols="12" sm="6">
                        <span style="font-weight: bold; font-size: 11pt">{{ colaborador.nome }}</span>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <input
                          ref="inputPdfFile"
                          type="file"
                          accept="application/pdf"
                          @change="addPdfFile(i, colaborador.cpf)"
                          style="display: none"
                        />
                        <v-btn
                          color="blue darken-2"
                          :title="colaborador.nome"
                          rounded
                          outlined
                          dark
                          small
                          @click="$refs.inputPdfFile[i].click()"
                        >
                          <v-icon left>mdi-file-pdf</v-icon>Adicionar PDF
                        </v-btn>
                        <span>{{ getNamePdf(colaborador.cpf) }}</span>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </template>

            <v-col v-if="todosColaboradores">
              <input
                ref="inputPdfFileAll"
                type="file"
                accept="application/pdf"
                @change="addPdfFile(0, 'all')"
                style="display: none"
              />
              <v-btn
                color="blue darken-2"
                title="Adicionar PDF"
                rounded
                outlined
                dark
                small
                @click="$refs.inputPdfFileAll.click()"
              >
                <v-icon left>mdi-file-pdf</v-icon>Adicionar PDF
              </v-btn>
              <span>{{ getNamePdf('all') }}</span>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-row dense>
            <v-col cols="12" align="center">
              <v-btn
                v-if="Object.keys(pdfFiles).length > 0"
                color="blue darken-2"
                rounded
                outlined
                dark
                small
                @click="sendPdf()"
              >
                <v-icon left>mdi-upload</v-icon>Enviar PDF
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { Arquivos } from "@/services/materiais";

export default {
  name: "PdfUpload",

  components: {
    SelectEmpresa: () => import("@/components/select/SelectEmpresa"),
    SelectColaborador: () => import("@/components/select/SelectColaborador"),
    SelectCampanha: () => import("@/components/select/SelectCampanha")
  },

  data() {
    return {
      empresas: [],
      colaboradores: [],
      todosColaboradores: true,

      pdfFiles: new Object()
    };
  },

  methods: {
    addPdfFile(index, cpf) {
      let file =
        cpf != "all"
          ? this.$refs.inputPdfFile[index].files[0]
          : this.$refs.inputPdfFileAll.files[0];

      if (cpf == "all") {
        this.pdfFiles = new Object();
      }
      this.pdfFiles[cpf] = file;
      this.$forceUpdate();
    },

    getNamePdf(cpf) {
      let file = this.pdfFiles[cpf];
      return file ? file.name : "";
    },

    sendPdf() {
      if (!this.campanha) {
        this.$toast.warning("Selecione uma campanha");
        return;
      }

      if (this.todosColaboradores) this.sendPdfAllColaboradores();
      else this.sendPdfByColaborador();
    },

    async sendPdfAllColaboradores() {
      let descricao = await this.$swal.inputText(
        "Descrição para o PDF",
        true,
        "Descrição"
      );
      if (!descricao || descricao == "") {
        this.$toast.warning("É necessário informar descrição do PDF");
        return;
      }

      try {
        this.$loading.setLoading(true, "Enviando para todos vendedores");

        for (const empresa of this.empresas) {
          await new Arquivos().uploadPdfByColaborador(
            empresa,
            "public",
            this.campanha,
            descricao,
            this.pdfFiles["all"]
          );
        }

        this.$swal.success("PDF enviado com sucesso");
        this.pdfFiles = new Object();
      } catch (error) {
        console.error(error);
        this.$swal.error(`Erro ao enviar pdf: ${JSON.stringify(error)}`);
      } finally {
        this.$loading.setLoading(false);
      }
    },

    async sendPdfByColaborador() {
      let descricao = await this.$swal.inputText(
        "Descrição para o PDF",
        true,
        "Descrição"
      );
      if (!descricao || descricao == "") {
        this.$toast.warning("É necessário informar descrição do PDF");
        return;
      }

      try {
        for (let empresa of this.empresas) {
          const colaboradoresDaEmpresa = this.colaboradores
            .map(colaborador =>
              colaborador.empresas.indexOf(empresa) >= 0 ? colaborador : ""
            )
            .filter(colaborador => colaborador !== "");

          if (colaboradoresDaEmpresa.length > 0) {
            for (const colaborador of colaboradoresDaEmpresa) {
              this.$loading.setLoading(
                true,
                `Enviando PDF do vendedor: ${colaborador.nome}`
              );
              await new Arquivos().uploadPdfByColaborador(
                empresa,
                colaborador.cpf,
                this.campanha,
                descricao,
                this.pdfFiles[colaborador.cpf]
              );
            }
          }
        }

        this.$swal.success("PDF enviados com sucesso");
        this.pdfFiles = new Object();
      } catch (error) {
        console.error(error);
        this.$swal.error(error);
      } finally {
        this.$loading.setLoading(false);
      }
    }
  },

  watch: {
    todosColaboradores() {
      this.pdfFiles = new Object();
    }
  }
};
</script>
